import { FC, ReactNode } from "react"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"

interface PreferencesRowProps {
   title: string
   description: string
   children: ReactNode
}

const PreferencesRow: FC<PreferencesRowProps> = ({
   title,
   description,
   children,
}) => {
   return (
      <GridItem
         size={12}
         className="preferences__row"
      >
         <Grid columnGap={24}>
            <GridItem
               xs={6}
               sm={5}
               md={4}
               lg={4}
            >
               <div className="preferences__row-content">
                  <div className="preferences__row-title">{title}</div>
                  <div className="preferences__row-description">
                     {description}
                  </div>
               </div>
            </GridItem>

            <GridItem
               xs={5}
               sm={5}
               md={5}
               lg={3}
            >
               {children}
            </GridItem>

            <GridItem
               xs={1}
               sm={2}
               md={3}
               lg={5}
            />
         </Grid>
      </GridItem>
   )
}

export default PreferencesRow
